import React, { useState, useEffect } from 'react';

const PhoneInput = ({ value, onChange, ...props }) => {
  const [formattedPhone, setFormattedPhone] = useState('');

  // Форматирование телефона при инициализации
  useEffect(() => {
    if (value) {
      setFormattedPhone(formatPhoneNumber(value));
    }
  }, [value]);

  const formatPhoneNumber = (value) => {
    // Удаляем все нецифровые символы
    const cleaned = ('' + value).replace(/\D/g, '');

    // Ограничиваем длину до 11 цифр (для российских номеров)
    const limited = cleaned.slice(0, 11);

    // Всегда добавляем +7, если номер не начинается с 7 или 8
    let match;
    if (limited.length === 0) {
      return '';
    } else if (limited.length === 1) {
      match = limited.match(/(\d{1})/);
      if (match) {
        if (match[1] === '7' || match[1] === '8') {
          return '+7';
        } else {
          return '+7 ' + match[1];
        }
      }
    } else if (limited.length === 2) {
      match = limited.match(/(\d{1})(\d{1})/);
      if (match) {
        if (match[1] === '7' || match[1] === '8') {
          return '+7 ' + match[2];
        } else {
          return '+7 ' + match[1] + match[2];
        }
      }
    } else if (limited.length <= 4) {
      match = limited.match(/(\d{1})(\d{0,3})/);
      if (match) {
        if (match[1] === '7' || match[1] === '8') {
          return '+7 ' + match[2];
        } else {
          return '+7 ' + match[1] + match[2];
        }
      }
    } else if (limited.length <= 7) {
      match = limited.match(/(\d{1})(\d{3})(\d{0,3})/);
      if (match) {
        if (match[1] === '7' || match[1] === '8') {
          return '+7 (' + match[2] + ') ' + match[3];
        } else {
          return '+7 (' + match[1] + match[2].slice(0, 2) + ') ' + match[2].slice(2) + match[3];
        }
      }
    } else if (limited.length <= 9) {
      match = limited.match(/(\d{1})(\d{3})(\d{3})(\d{0,2})/);
      if (match) {
        if (match[1] === '7' || match[1] === '8') {
          return '+7 (' + match[2] + ') ' + match[3] + '-' + match[4];
        } else {
          return '+7 (' + match[1] + match[2].slice(0, 2) + ') ' + match[2].slice(2) + match[3] + '-' + match[4];
        }
      }
    } else {
      match = limited.match(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{0,2})/);
      if (match) {
        if (match[1] === '7' || match[1] === '8') {
          return '+7 (' + match[2] + ') ' + match[3] + '-' + match[4] + '-' + match[5];
        } else {
          const cleanNumber = match[1] + match[2] + match[3] + match[4] + match[5];
          const restNumber = cleanNumber.slice(1);
          return '+7 (' + restNumber.slice(0, 3) + ') ' + restNumber.slice(3, 6) + '-' + restNumber.slice(6, 8) + '-' + restNumber.slice(8, 10);
        }
      }
    }

    return limited;
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;

    // Удаляем все нецифровые символы
    let cleanValue = inputValue.replace(/\D/g, '');

    // Если пользователь пытается ввести первую цифру не 7 или 8, автоматически добавляем 7 в начало
    if (cleanValue.length === 1 && cleanValue !== '7' && cleanValue !== '8') {
      cleanValue = '7' + cleanValue;
    }

    // Если номер начинается с 8, заменяем на 7
    if (cleanValue.length > 0 && cleanValue[0] === '8') {
      cleanValue = '7' + cleanValue.slice(1);
    }

    // Ограничиваем до 11 цифр (7 + 10 цифр номера)
    cleanValue = cleanValue.slice(0, 11);

    const formatted = formatPhoneNumber(cleanValue);
    setFormattedPhone(formatted);

    // Передаем очищенный номер наверх (без форматирования)
    onChange({
      target: {
        name: 'phone',
        value: cleanValue
      }
    });
  };

  const handleKeyDown = (e) => {
    // Разрешаем только цифры, backspace, delete, стрелки и tab
    if (
      !/[0-9]/.test(e.key) &&
      e.key !== 'Backspace' &&
      e.key !== 'Delete' &&
      e.key !== 'ArrowLeft' &&
      e.key !== 'ArrowRight' &&
      e.key !== 'Tab'
    ) {
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text');
    const cleanText = pastedText.replace(/\D/g, '');

    // Если вставляемый текст начинается с 8, заменяем на 7
    const normalizedText = cleanText.length > 0 && cleanText[0] === '8'
      ? '7' + cleanText.slice(1)
      : cleanText;

    const formatted = formatPhoneNumber(normalizedText);
    setFormattedPhone(formatted);

    onChange({
      target: {
        name: 'phone',
        value: normalizedText.slice(0, 11)
      }
    });
  };

  return (
    <input
      {...props}
      type="tel"
      value={formattedPhone}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onPaste={handlePaste}
      placeholder="+7 (___) ___-__-__"
      maxLength={18} // Максимальная длина с учетом форматирования
    />
  );
};

export default PhoneInput;